require('angular')

NumberService = require('./number-service')
SmallSizedDecimalDirective = require('./small-sized-decimal-directive.coffee')
percentToFormattedString = require('./percent-to-formatted-string.coffee')

modules = []

angular.module 'gnp-number', modules
  .factory "NumberService", NumberService
  .directive 'gnpSmallSizedDecimal', SmallSizedDecimalDirective
  .filter 'percentToFormattedString', percentToFormattedString



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/components/number/number-module.coffee